import React from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';


const NumberRangeField = ({
    fromName,
    toName,
    fromLabel,
    toLabel,
    fromValue,
    toValue,
    onChange,
    fromError,
    toError,
    unit
}) => {


    const handleFromChange = (event) => {
        const { value } = event.target;
        const newValue = Number(value);
        if (newValue > 0) {
            onChange({ target: { name: fromName, value: newValue } });
        } else if (!value) {
            onChange({ target: { name: fromName, value: '' } })
        }
    };

    const handleToChange = (event) => {
        const { value } = event.target;
        const newValue = Number(value);
        if (newValue > 0) {
            onChange({ target: { name: toName, value: newValue } });
        } else if (!value) {
            onChange({ target: { name: toName, value: '' } })
        }
    };

    return (
        <Box display="flex" alignItems="center">
            <TextField
                size="small"
                fullWidth
                label={fromLabel}
                value={fromValue}
                onChange={handleFromChange}
                error={!!fromError}
                helperText={fromError ?? ''}
                InputProps={{
                    endAdornment: <InputAdornment position="start">{unit}</InputAdornment>
                }}
                inputProps={{ inputMode: 'numeric' }}
                sx={{ mr: 2 }}
            />
            <TextField
                size="small"
                fullWidth
                label={toLabel}
                value={toValue}
                onChange={handleToChange}
                error={!!toError}
                helperText={toError ?? ''}
                InputProps={{
                    endAdornment: <InputAdornment position="start">{unit}</InputAdornment>
                }}
                inputProps={{ inputMode: 'numeric' }}
            />
        </Box>
    );
};

export default NumberRangeField;
